import React, { useState, useCallback } from "react";
import CountrySelect from "./CountrySelect";

function CountryList({ countries }) {
  const [countryList, setCountryList] = useState(countries);

  const setAllEnabled = useCallback((enabled) => {
    setCountryList((prev) =>
      prev.map((country) => ({ ...country, enabled }))
    );
  }, []);

  const toggleCountry = useCallback((id) => {
    setCountryList((prev) =>
      prev.map((country) =>
        country.id === id ? { ...country, enabled: !country.enabled } : country
      )
    );
  }, []);

  return (
    <div className="overflow-auto" style={{ maxHeight: "300px" }}>
      <div className="mb-2">
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={() => setAllEnabled(true)}
        >
          Select all
        </button>
        {" / "}
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={() => setAllEnabled(false)}
        >
          Disable all
        </button>
      </div>
      {countryList.map((country) => (
        <CountrySelect
          key={country.id}
          id={country.id}
          name={country.name}
          enabled={country.enabled}
          onToggle={toggleCountry}
        />
      ))}
    </div>
  );
}

export default CountryList;
